import React from 'react';
import { useTranslation } from 'react-i18next';
import { Paragraph } from '@sentara-health/optimahealth_web';

// Define the interface for the props passed to PasswordStrengthMeter component
interface PasswordMeter {
  inputStrengthClass: string;
}

// Define the PasswordStrengthMeter component
const PasswordStrengthMeter: React.FC<PasswordMeter> = ({
  inputStrengthClass,
}) => {
  // Initialize localization using react-i18next
  const { t } = useTranslation();

  return (
    <>
      {/* Container for the password strength bar */}
      <div className="strength-bar-container">
        {/* Password strength bar */}
        <div
          data-testid="passwordStrenghtValidator"
          className={inputStrengthClass}
        ></div>
      </div>
      {/* Container for password strength labels */}
      <div className="d-flex justify-content-between mx-0 mt-1 mb-3">
        {/* Weak password label */}
        <Paragraph text={t('common.weak')} variant="medium" data-testid="passwordStrenghtValidatorWeak" className="pt-2 mt-1" />

        {/* Medium password label */}
        <Paragraph text={t('common.medium')} variant="medium" data-testid="passwordStrenghtValidatorMedium" className="pt-2 mt-1" />

        {/* Strong password label with recommended note */}
        <Paragraph text={`${t('common.strong')} (${t('common.recommended')})`} variant="medium" data-testid="passwordStrenghtValidatorStrong" className="pt-2 mt-1" />
      </div>
    </>
  );
};

export default PasswordStrengthMeter;
